import React from 'react';
import { motion } from 'framer-motion';
import { Brain, PenTool, Rocket, Layout } from 'lucide-react';
const steps = [{
  id: 1,
  title: 'Estrategia AI',
  description: 'Analizamos tu mercado y competencia con inteligencia artificial para crear la estrategia perfecta.',
  icon: Brain,
  color: 'text-purple-400'
}, {
  id: 2,
  title: 'Copy Persuasivo',
  description: 'Redactamos textos que conectan emocionalmente y convierten visitantes en clientes.',
  icon: PenTool,
  color: 'text-pink-400'
}, {
  id: 3,
  title: 'Diseño Cósmico',
  description: 'Creamos un diseño visual impactante que refleja la esencia de tu marca.',
  icon: Layout,
  color: 'text-cyan-400'
}, {
  id: 4,
  title: 'Integraciones & Lanzamiento',
  description: 'Conectamos todo: dominio, analytics, Meta Ads, WhatsApp. Listo para vender.',
  icon: Rocket,
  color: 'text-yellow-400'
}];
export function MethodSection() {
  return <section id="metodo" className="py-24 bg-[#050510] relative" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="text-center mb-20" data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-118">
            El Método{' '}
            <span className="text-gradient-cosmic" data-id="element-119">A-Z UltraExpress™</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-120">
            Cómo logramos resultados extraordinarios en tiempo récord
          </p>
        </div>

        <div className="relative" data-id="element-121">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-purple-900 via-pink-900 to-purple-900 -translate-y-1/2 z-0" data-id="element-122" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 relative z-10" data-id="element-123">
            {steps.map((step, index) => <motion.div key={step.id} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative group" data-id="element-124">
                <div className="flex flex-col items-center text-center" data-id="element-125">
                  <div className="relative mb-6" data-id="element-126">
                    <div className="w-20 h-20 rounded-full bg-[#0a0a1a] border-2 border-purple-500/30 flex items-center justify-center group-hover:border-pink-500 group-hover:shadow-[0_0_20px_rgba(236,72,153,0.5)] transition-all duration-300 z-10" data-id="element-127">
                      <step.icon className={`w-8 h-8 ${step.color}`} data-id="element-128" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center text-white font-bold text-sm shadow-lg" data-id="element-129">
                      {step.id}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-white mb-3 font-orbitron" data-id="element-130">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-131">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}